// /enter-school-code?mode=required|add (FR-024 to FR-027; P-JOIN-8, P-AUTH-2). `required` (after
// sign-in with no children): no way to Home; Log out, and Switch to school admin for a web dual-role
// user. `add` (004's entry points): Cancel goes back, else Home. A confirmed school hands off to Add
// student with source CODE.
import { useLocalSearchParams, useRouter } from "expo-router";

import { useSession, useSessionController } from "@/session/hooks";
import { usePlatform } from "@/session/platform";
import { servedRoles } from "@/session/store";
import { useChromeKind } from "@/shell/chrome/useChromeKind";
import { ScreenScaffold } from "@/shell/ScreenScaffold";
import { LinkButton } from "@/ui/LinkButton";

import { JOIN_COPY } from "./copy";
import { EnterSchoolCodeForm } from "./EnterSchoolCodeForm";
import { addStudentHref, handoff, type JoinHandoff } from "./handoff";
import { JoinLayout } from "./JoinLayout";

export function EnterSchoolCodeScreen() {
  const params = useLocalSearchParams<{ mode?: string }>();
  const mode = params.mode === "required" ? "required" : "add";
  const router = useRouter();
  const session = useSession();
  const platform = usePlatform();
  const controller = useSessionController();
  const phone = useChromeKind() === "mobile";
  const dualOnWeb =
    platform === "web" &&
    session.status === "signedIn" &&
    servedRoles(session.roles).includes("SCHOOL_ADMIN") &&
    servedRoles(session.roles).includes("PARENT");

  const footer =
    mode === "required" ? (
      <>
        {dualOnWeb ? (
          <LinkButton
            onPress={() =>
              void controller
                .switchRole("SCHOOL_ADMIN")
                .then(() => router.replace("/school"))
            }
          >
            {JOIN_COPY.codeStep.switchToSchoolAdmin}
          </LinkButton>
        ) : null}
        <LinkButton onPress={() => void controller.signOut("USER")}>
          {JOIN_COPY.codeStep.logOut}
        </LinkButton>
      </>
    ) : (
      <LinkButton
        onPress={() =>
          router.canGoBack() ? router.back() : router.replace("/")
        }
      >
        {JOIN_COPY.codeStep.cancel}
      </LinkButton>
    );

  const onConfirmed = (code: string, school: JoinHandoff["school"]) => {
    handoff.put({ code, source: "CODE", school });
    router.push(addStudentHref(code, "CODE"));
  };

  // Phones, opened to add a child: a pushed screen with the app bar; its arrow is the Cancel.
  if (phone && mode === "add") {
    return (
      <ScreenScaffold
        title={JOIN_COPY.codeStep.heading}
        testID="enter-school-code"
      >
        <EnterSchoolCodeForm showHeading={false} onConfirmed={onConfirmed} />
      </ScreenScaffold>
    );
  }

  return (
    // Phones in `required` mode: the first screen after sign-in, under the product header.
    <JoinLayout header={phone} testID="enter-school-code">
      <EnterSchoolCodeForm footer={footer} onConfirmed={onConfirmed} />
    </JoinLayout>
  );
}
